module.exports = __webpack_public_path__ + "static/summon-logo-blue-fb-15240bc570e1468aef9723a6028a29c5.png";